export default __webpack_public_path__ + "static/media/celebrate.1963600e.svg";